import "../styles.css"
export const Cashback=()=>{
    return(
        <div>
            <img className="cash-img" src="https://dao54xqhg9jfa.cloudfront.net/OMS-StaticBanner/68cf216b-52ea-2506-952f-f30c31a073e2/original/static-bank-units-June-web_(21).jpg?format=webp" alt="" />
        </div>
    )
}